export default {
  BusinessReportSaleGoods: {
    orderTime: '下单时间',
    // itemCodeName: '商品名称/编码',
    channel: '渠道',
    orderCount: '订单数',
    balanceOrderCount: '日均订单数',
    saleCount: '销量',
    balanceSaleCount: '日均销量',
    saleAmount: '销售金额',
    balanceSaleAmount: '日均销售金额',
    reverseItemCount: '退货数量',
    reverseAmount: '退货金额'
  }
};
